module.exports = __webpack_public_path__ + "static/media/mmt symbols.f8fa1c28.jpg";